/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { s as saveResumeDataForFm } from '../../../common-42e7d8d8.js';
import '../../../safe-data-66f20265.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';

function navigateBack(params, context) {
    saveResumeDataForFm(params);
    context === null || context === void 0 ? void 0 : context.WVCall('WVIdleFishApi.finish', params);
}

export { navigateBack as default };
